import React, { useEffect, useState } from "react";
import Show from "../../../utils/show.component";
import { AuthCardPopupMenu } from "./card-children/auth-card-popup-menu.component";
import {
  SetupAutoPayButton,
  EditAutoPayButton,
  MakePaymentButton,
} from "./card-children/card-payment-buttons.component";
import { usd } from "../../../utils/utils";
import moment from "moment";
import { formatLastFour } from "../misc/messaging-utils";
import { Button } from "react-bootstrap";
import { FuturePaymentCancellationModal } from "../modal/future-payment-cancellation-modal";

export const AuthPaymentLoanCard = (props) => {
  const selectPaymentType = (
    type,
    achIsAllowed,
    isPrincipalOnly = false,
    hasSelectedPayoff = false,
  ) => {
    props.closeAllPopupMenus();
    props.showAuthPaymentModal(
      true,
      type,
      props.AccountHash,
      achIsAllowed,
      props.IsOpenEndedLoan,
      isPrincipalOnly,
      hasSelectedPayoff,
    );
  };

  // Determine if the NextDueDate loan property matches the string that denotes
  // that there is no due date, and show N/A if there is none
  const hasDueDate = props.NextDueDate !== "0001-01-01T00:00:00" ? true : false;
  const lastFour = props.LastFour;

  return (
    <UpdatedLoanCard
      {...props}
      selectPaymentType={selectPaymentType}
      hasDueDate={hasDueDate}
      lastFour={lastFour}
    />
  );
};

const UpdatedLoanCard = (props) => {
  const { selectPaymentType, hasDueDate, lastFour } = props;

  const futureDatedPayments =
    props.ScheduledPayment && props.ScheduledPayment.FutureDatedPayments
      ? props.ScheduledPayment.FutureDatedPayments
      : [];

  const isCreditCard = () => {
    return props.IsCreditOrExternalAccount;
  };

  const showPaymentButton = () => {
    const shouldShow = !isCreditCard() || props.OverrideShowCreditCardPaymentOption;
    return shouldShow;
  };

  const isCreditCardWithNoPayableAccounts = () => {
    return isCreditCard() && !props.internalAccounts.length;
  };

  const showNoPayableAccountsForCreditCard = () => {
    const shouldShow = props.PaymentAllowed && isCreditCardWithNoPayableAccounts();

    return shouldShow;
  };

  const showPastDueBar = (amountPastDue, showRegularAmountWarning, scheduledAchPaysPastDue) => {
    const show =
      amountPastDue && !showRegularAmountWarning && !scheduledAchPaysPastDue ? true : false;

    return show;
  };

  const overdueBar = () => {
    const show = showPastDueBar(
      props.AmountPastDue,
      props.ShowRegularAmountWarning,
      props.ScheduledACHPaysPastDue,
    );

    const amount = show ? props.AmountPastDue : 0;

    if (show) {
      return (
        <div className="row auth-card-overdue-bar">
          <div className="m-auto px-4 d-flex">
            <div>PAST DUE</div>
            <div className="pl-2">Pay {usd.format(amount)} to bring current.</div>
          </div>
        </div>
      );
    }

    return null;
  };

  const showSetupAutoPayButton = () => {
    return (
      props.RecurringPayment === null &&
      props.NextDueDate &&
      props.RecurringPaymentIsAllowed === true &&
      !isCreditCard()
    );
  };

  const showScheduledPaymentBar = () => {
    let show = false;

    if (props.ScheduledPayment && props.ScheduledPayment.Amount > 0) {
      show = true;
    }

    return show;
  };

  const scheduledPaymentBar = () => {
    const show = showScheduledPaymentBar();
    const amount = show ? props.ScheduledPayment.Amount : 0;

    if (show) {
      return (
        <div className="row auth-card-scheduled-payments-bar">
          <div className="m-auto px-4 d-flex">
            <div>{usd.format(amount)} Payment Pending</div>
          </div>
        </div>
      );
    }

    return null;
  };

  // If we are not showing available credit, then vertically center the balance and due date fields
  const getSecondaryFieldStyling = () => {
    return props.IsOpenEndedLoan
      ? {}
      : { display: "flex", flexDirection: "column", justifyContent: "center" };
  };

  const hasAnyAdditionalIndicators =
    showPastDueBar(props.AmountPastDue, props.ShowRegularAmountWarning) ||
    showScheduledPaymentBar() ||
    futureDatedPayments.length;

  return (
    <div
      className="mb-4 px-0 container-fluid auth-payment-container"
      style={{
        maxWidth: "770px",
        paddingBottom: hasAnyAdditionalIndicators ? "0px" : "15px",
      }}
    >
      <div className="px-3">
        <AuthCardPopupMenu
          {...props}
          showPopupMenu={props.cardState.showPopupMenu}
          selectPaymentType={selectPaymentType}
          lastFour={lastFour}
        />
      </div>
      <div className="m-auto loan-card-interior" style={{ overflow: "hidden" }}>
        <div className="row pt-2 pb-4 bold f20" style={{ maxWidth: "400px" }}>
          <div className="col-12 d-flex">
            <div className="ellipsis">{`${props.Collateral || props.LoanType}`}</div>
            <div className="text-end pl-2">{`${formatLastFour(lastFour)}`}</div>
          </div>
        </div>
        <div className="row pb-3">
          <div
            className="col-sm-5"
            style={{ borderRight: props.windowWidth > 575 ? "1px solid lightgray" : "" }}
          >
            <div className="row px-3">
              <div className="col-12 p-0">
                <div>Amount Due</div>
                <div
                  className="bold"
                  style={{ fontSize: "40px", color: "#00558c" }}
                  data-e2e-id={"amountDue-" + lastFour}
                >
                  {usd.format(props.AmountDue)}
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6" style={getSecondaryFieldStyling()}>
            <div className="row px-3 jc-between">
              <div>Due Date</div>
              <div className="bold" data-e2e-id={"nextDueDate-" + lastFour}>
                {props.NextDueDate != null ? moment(props.NextDueDate).format("MM/DD/YYYY") : "N/A"}
              </div>
            </div>
            <div className="row px-3 jc-between">
              <div>Current Balance</div>
              <div className="bold" data-e2e-id={"currentBalance-" + lastFour}>
                {usd.format(props.CurrentBalance)}
              </div>
            </div>
            <Show condition={props.IsOpenEndedLoan}>
              <div className="row px-3 jc-between">
                <div>Available Credit</div>
                <div className="bold" data-e2e-id={"availableCredit-" + lastFour}>
                  {usd.format(props.AvailableCredit)}
                </div>
              </div>
            </Show>
          </div>
        </div>

        <div className="row pb-2">
          <Show condition={!props.PaymentAllowed}>
            <div
              className="auth-card-message mx-3"
              dangerouslySetInnerHTML={{ __html: props.PaymentNotAllowedReasonHtml }}
            />
          </Show>
          <Show condition={showNoPayableAccountsForCreditCard()}>
            <div className="auth-card-message mx-3">
              This loan cannot be paid at this time. Please contact us at{" "}
              <span className="bold">888.267.7200</span>.
            </div>
          </Show>
          <Show condition={props.PaymentAllowed}>
            <Show condition={props.ShowRegularAmountWarning}>
              <div className="auth-card-message mx-3">
                Please Note: Next month’s billing cycle has begun, so the Amount Due above may
                reflect this month and next month’s payment. Your regular amount due is{" "}
                {usd.format(props.RegularPaymentAmount)}
              </div>
            </Show>
            <div className="col-sm-5 col-xs-12">
              {/* do not allow recurring payment setup if dna does not have a due date for the loan */}
              <SetupAutoPayButton
                show={showSetupAutoPayButton()}
                selectPaymentType={selectPaymentType}
                {...props}
              />
              {/* always show the edit autopay button if we have an autopay setup, if clicked we'll check if edit is allowed and notify the user */}
              <EditAutoPayButton
                show={props.RecurringPayment !== null}
                selectPaymentType={selectPaymentType}
                {...props}
              />
            </div>
            <div className="col-sm-5 col-xs-12">
              <MakePaymentButton
                show={showPaymentButton()}
                selectPaymentType={selectPaymentType}
                {...props}
                lastFour={lastFour}
              />
            </div>
            <div className="col-sm-2"></div>
          </Show>
        </div>
      </div>
      <div
        className="container-fluid"
        style={{
          overflow: "hidden",
          borderRadius: "0px 0px 12px 12px",
        }}
      >
        {scheduledPaymentBar()}
        {overdueBar()}
        {futureDatedPayments.map((payment, index) => (
          <FutureDatedPaymentBar
            key={index}
            hasDivider={index !== 0}
            amount={payment.Amount}
            date={payment.ScheduledDate}
            loanDescription={`${props.Collateral || props.LoanType} ${formatLastFour(lastFour)}`}
            paymentId={payment.ScheduledPaymentId}
            paymentAccount={payment.AccountNumber || ""}
          />
        ))}
      </div>
    </div>
  );
};

const FutureDatedPaymentBar = ({
  amount,
  date,
  loanDescription,
  paymentId,
  paymentAccount,
  hasDivider,
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleCloseFuturePaymentCancellationModals = () => {
      setModalOpen(false);
    };

    window.addEventListener(
      "closeFuturePaymentCancellationModals",
      handleCloseFuturePaymentCancellationModals,
    );

    return () =>
      window.removeEventListener(
        "closeFuturePaymentCancellationModals",
        handleCloseFuturePaymentCancellationModals,
      );
  }, []);

  // Not tied to a breakpoint, just based on the space available
  const isSmallDisplay = windowWidth <= 500;

  if (!amount || !date) {
    return null;
  }

  return (
    <div className="row auth-card-future-payments-bar">
      <div className="col-12 p-0">
        <div style={{ height: "3px", backgroundColor: "#99c2ab" }}></div>
      </div>
      <div className="col-12">
        <div className="d-flex align-items-center">
          <div
            className="m-auto"
            style={{
              paddingLeft: isSmallDisplay ? "0px" : "70px",
            }}
          >
            {usd.format(amount)} Scheduled on {moment(date).format("MM/DD/YYYY")}
          </div>
          <Button
            variant="outline-dark"
            className="m-0"
            size="sm"
            style={{
              border: "none",
              textDecoration: "underline",
            }}
            onClick={() => {
              window.dispatchEvent(new CustomEvent("closeAllPopupMenusAndAuthModals"));
              setModalOpen(true);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
      <FuturePaymentCancellationModal
        show={modalOpen}
        paymentId={paymentId}
        loanDescription={loanDescription}
        amount={amount}
        date={date}
        paymentAccount={paymentAccount}
        onHide={() => setModalOpen(false)}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/auth-payment-loan-card.component.js